export const initialState = {
    basket: [],
    //The user located in App.js
    user: null
}

const reducer = (state, action) => {

    switch (action.type) {
        case "ADD_TO_BASKET":
            return {
                ...state,
                basket: [...state.basket, action.item],
            };

        case "REMOVE_FROM_BASKET":
            //Find index of the item to be removed from the checkout page
            const index = state.basket.findIndex(
                (basketItem) => basketItem.id === action.id);

            let newBasket = [...state.basket]

            if (index >= 0) {
                //cutting the item at index position
                newBasket.splice(index, 1);
            }
            else {
                console.warn("Can't remove product (id: ${action.id} as it isn't in the basket!");
            }

            return {
                ...state,
                basket: newBasket
            }

        case "SET_USER":
            return {
                ...state,
                user: action.user,
            };

        default:
            return state;
    }
}

export default reducer;